export default "__VITE_ASSET__8b5ad8f7__"